import "./token.mjs";
import "ethers";
import "@deorderbook/contracts/abi";
import "../store/provider.mjs";
import "@deorderbook/contracts";
import "../store/subgraph.mjs";
import { useTestTokenPoolContract as e } from "../store/testTokenPoolContract.mjs";
async function s() {
  const t = await e().getWhitelistedTokensLength(), n = [];
  for (let a = 0; a < t; ++a)
    n.push(e().whitelistedTokens(a));
  return await Promise.all(n);
}
async function h(t) {
  return await e().lastWithdrawTimestamp(t);
}
async function p() {
  return await e(!0).withdrawTokens();
}
async function o(t) {
  return await e().tokenTransferAmounts(t);
}
async function f() {
  const t = await s(), n = /* @__PURE__ */ new Map(), a = t.map(
    (i) => o(i)
  ), r = await Promise.all(a);
  for (let i = 0; i < t.length; ++i)
    n.set(t[i], r[i]);
  return n;
}
async function k(t) {
  return await e().isWhitelisted(t);
}
async function W(t) {
  return await e().isTokenWhitelisted(t);
}
async function y(t, n) {
  return await e(!0).updateWhitelist(t, n);
}
async function g(t, n) {
  return await e(!0).addTokenToWhitelist(t, n);
}
async function A(t) {
  return await e(!0).removeTokenFromWhitelist(t);
}
async function v(t, n) {
  return await e(!0).updateTokentransferAmounts(
    t,
    n
  );
}
async function P(t, n) {
  return await e(!0).depositTokens(t, n);
}
async function F() {
  return await e(!0).withdrawAllTokens();
}
async function H(t) {
  return await e(!0).updateWithdrawalIntervalHours(t);
}
export {
  g as addTokenToWhitelist,
  P as depositTokens,
  h as getLastWithdrawTimestamp,
  p as getTestTokens,
  o as getTokenTransferAmount,
  f as getTokenTransferAmountsMap,
  s as getWhitelistedTokens,
  W as isTokenWhitelisted,
  k as isWhitelisted,
  A as removeTokenFromWhitelist,
  v as updateTokentransferAmounts,
  y as updateWhitelist,
  H as updateWithdrawalIntervalHours,
  F as withdrawAllTokens
};
//# sourceMappingURL=test_token_pool.mjs.map
